/**
 * @module byo-bundle/constants
 * DOM selectors and CSS classes for the build-your-own bundle element.
 */

export const SELECTORS = {
  slot: '.byo-bundle__slot',
  open: '[data-byo-open]',
  close: '[data-byo-close]',
  select: '[data-byo-select]',
  remove: '[data-byo-remove]',
  addSingle: '[data-byo-add-single]',
  pick: '[data-byo-pick]',
  drawer: 'dialog',
  card: '.byo-bundle__card',
  cardClone: '.byo-bundle__card-media, .byo-bundle__card-info',
  cardTitle: '.byo-bundle__card-title',
  rowLabelled: '[data-byo-add-single][data-template], [data-byo-remove][data-template]',
  count: '[data-byo-count]',
  counter: '[data-byo-counter]',
  cta: '.byo-bundle__cta',
  submitButton: '.byo-bundle__submit',
  errorWrapper: '.product-form__error-message-wrapper',
  stepperValue: '.virtual-collection__stepper-value',
};

export const CLASSES = {
  complete: 'byo-bundle--complete',
  filled: 'byo-bundle__slot--filled',
  next: 'byo-bundle__slot--next',
  selected: 'byo-bundle__card--selected',
  bodyLock: 'byo-bundle-scroll-lock',
  loading: 'loading',
};
